export enum ROUTES_PATH {
  DASHBOARD = '',
  MAPS = 'maps',
  AI_AGENTS = 'ai-agents',
  CHANGES = 'changes',
  SF_ORGS = 'referencemodels-external',
  REFERENCE_MODEL = 'referencemodels',
  METADATA_DICTIONARIES = 'metadata-dictionaries',
  URL_LIBRARY = 'url-library',
  RELEASES = 'releases',
  SPACES = 'teams',
  STORIES = 'stories',
  REQUIREMENTS = 'requirements',
  FEEDBACKS = 'feedback',
  PROFILE = 'profile',
  SIGN_IN = 'signin',
  SIGN_UP = 'signup',
  SIGN_UP_SUCCESS = 'signup-success',
  FORGOT_PASS = 'forgot-pass',
  NEW_PASS = 'new-pass',
  AUTH = 'auth',
  ACCOUNT_ACCEPT = 'account-accept',
  ACCOUNT = 'account',
  TASKS = 'tasks',
  SF_REFRESH_CALLBACK = 'auth/refresh/callback',
  SF_CONNECT_CALLBACK = 'auth/connect/callback',
  NOT_FOUND = '404',
  DIAGRAM_EDITOR_REQUEST_ACCESS = 'request-access/:id',
  SETUP_TWO_FA = 'setup-2fa',
  VERIFY_TWO_FA = 'verify-2fa',
  PROBLEMS_SELECT = 'problems-select',
  USAGE = 'usage',
  DECISION_ENGINE = 'decision-engine'
}
